import { render, staticRenderFns } from "./pddPop.vue?vue&type=template&id=e437704a&scoped=true"
import script from "./pddPop.vue?vue&type=script&lang=js"
export * from "./pddPop.vue?vue&type=script&lang=js"
import style0 from "./pddPop.vue?vue&type=style&index=0&id=e437704a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e437704a",
  null
  
)

export default component.exports